import React, { useEffect, useState  } from 'react';
import { Formik } from "formik";
import { Row } from "react-bootstrap";
import InputField from "../InputField/InputField";
import Axios from '../../lib/axios/axiosInstance';
import { Slide, toast } from 'react-toastify';

const ApprovalSetting =(props) => {
    
    const [cartDetails, setCartDetails] = useState(false);
    const [justForShow, setJustForShow] = useState(false);

    const addRemark = (value,id)=>{
        cartDetails[`approver${id}comment`]=value;
        setCartDetails(cartDetails);
    }

    const handleClick = async (event) => {
        const remark=cartDetails[`approver${event.lvl}comment`];
        if(event.result ==='a' || (event.result ==='r' && remark))
        {
            setCartDetails(false);
            const jsonData={
                approval: {
                 level:event.lvl,
                 result:event.result ==='a'?"approve":"reject",
                 remark:remark
                }
            };
            await Axios.post(`/cart/approval/${cartDetails.refnum}`,jsonData)
                .then(async (data) => {
                    if (data.data.success) {
                        setCartDetails(data.data.data.carth)
                        toast.success(`${event.result === 'a' ? "Approved" : "Rejected"} successfully.`, {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 3000,
                            transition: Slide,
                        });
                    }
                    else {
                        toast.error(data.data.error, {
                            position: toast.POSITION.TOP_CENTER,
                            autoClose: 3000,
                            transition: Slide,
                        });
                    }
                })
                .catch(error =>{
                    toast.error(error.message, {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000,
                        transition: Slide,
                    });
                })
        }
        else{
            toast.error(`For rejection remark can't be blank !`, {
                position: toast.POSITION.TOP_CENTER,
                autoClose: 3000,
                transition: Slide,
            });
        }
    
    }

    const handleRequestBkup = async (event) => {
        setCartDetails(false);
        const jsonData = {
            bkuprequest: {
                level: event.lvl
            }
        };
        await Axios.post(`/cart/bkuprequest/${cartDetails.refnum}`, jsonData)
            .then(async (data) => {
                setCartDetails(data.data.data.carth)
                toast.success(`Request for backup approver sent successfully.`, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            })
            .catch(error => {
                toast.error(error.message, {
                    position: toast.POSITION.TOP_CENTER,
                    autoClose: 3000,
                    transition: Slide,
                });
            })
    }

    useEffect(() => {
        setJustForShow(props.justForShow);
        if(props.carth)setCartDetails(props.carth);
    }, [props.carth]);

    return (
      <Formik>
          {() => (
            <>
            {cartDetails && <>
                <Row style={{display: "flex", margin:"auto"}}>
                    <div className='col-md-2' style={{margin:"auto 5px"}}>{`Approver 1`}</div>
                    <div className='col-md-2'>
                        <InputField Name={`approver1status`} ReadOnly={true} value={cartDetails.approver1status} Labels="Status" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver1`} ReadOnly={true} value={cartDetails.approver1} Labels="Approved/Rejected By" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver1date`} ReadOnly={true} value={cartDetails.approver1date?cartDetails.approver1date.split('T')[0]:""} Labels="Approved/Rejected Date" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver1comment`} ReadOnly={justForShow??false} defaultValue={cartDetails.approver1comment} onChange={(e)=>addRemark(e.target.value,1)} Labels="Remark" Type="text" />
                    </div>
                    <div className='col-md-2' style={{margin:"auto 5px"}}>
                    {cartDetails.approver1bkrequestaccess &&
                        <>
                        <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>handleRequestBkup({lvl:1})}>Request Backup Approver</button>
                        </>
                    }    
                    {cartDetails.approver1access &&
                        <>
                        <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>handleClick({lvl:1,result:'a'})}>Approve</button>|
                        <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>handleClick({lvl:1,result:'r'})}>Reject</button>
                        </>
                    }
                    </div>
                </Row>
                {cartDetails.approver2status!='NA' &&
                <Row style={{display: "flex", margin:"auto"}}>
                    <div className='col-md-2' style={{margin:"auto 5px"}}>{`Approver 2`}</div>
                    <div className='col-md-2'>
                        <InputField Name={`approver2status`} ReadOnly={true} value={cartDetails.approver2status} Labels="Status" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver2`} ReadOnly={true} value={cartDetails.approver2} Labels="Approved/Rejected By" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver2date`} ReadOnly={true} value={cartDetails.approver2date?cartDetails.approver2date.split('T')[0]:""} Labels="Approved/Rejected Date" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver2comment`} ReadOnly={justForShow??false} defaultValue={cartDetails.approver2comment} onChange={(e)=>addRemark(e.target.value,2)} Labels="Remark" Type="text" />
                    </div>
                    
                    <div className='col-md-2' style={{margin:"auto 5px"}}>
                    {cartDetails.approver2bkrequestaccess &&
                        <>
                        <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>handleRequestBkup({lvl:1})}>Request Backup Approver</button>
                        </>
                    }
                    {cartDetails.approver2access &&
                        <>
                        <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>handleClick({lvl:2,result:'a'})}>Approve</button>|
                        <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>handleClick({lvl:2,result:'r'})}>Reject</button>
                        </>
                    }
                    </div>
                </Row>}
                {cartDetails.approver3status!='NA' &&
                <Row style={{display: "flex", margin:"auto"}}>
                    <div className='col-md-2' style={{margin:"auto 5px"}}>{`Approver 3`}</div>
                    <div className='col-md-2'>
                        <InputField Name={`approver3status`} ReadOnly={true} value={cartDetails.approver3status} Labels="Status" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver3`} ReadOnly={true} value={cartDetails.approver3} Labels="Approved/Rejected By" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver3date`} ReadOnly={true} value={cartDetails.approver3date?cartDetails.approver3date.split('T')[0]:""} Labels="Approved/Rejected Date" Type="text" />
                    </div>
                    <div className='col-md-2'>
                        <InputField Name={`approver3comment`} ReadOnly={justForShow??false} defaultValue={cartDetails.approver3comment} onChange={(e)=>addRemark(e.target.value,3)} Labels="Remark" Type="text" />
                    </div>
                    <div className='col-md-2' style={{margin:"auto 5px"}}>
                    {cartDetails.approver3bkrequestaccess &&
                        <>
                        <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>handleRequestBkup({lvl:3})}>Request Backup Approver</button>
                        </>
                    }
                    {cartDetails.approver3access &&
                        <>
                        <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>handleClick({lvl:3,result:'a'})}>Approve</button>|
                        <button className='btn btn-sm' style={{background:"none", color:"blue"}} onClick={()=>handleClick({lvl:3,result:'r'})}>Reject</button>
                        </>
                    }
                    </div>
                </Row>}
                </>
            }
            </>
          )}
        </Formik>
    )
}

export default ApprovalSetting